'use client';

import { Center, Container } from '@chakra-ui/react';

import { JobApplicationContainer } from '@/modules/job/presentation/containers';

type JobApplicationScreenProps = {
	jobId: string
};

export const JobApplicationScreen = ({ jobId }: JobApplicationScreenProps) => {
	return (
		<Center h="100%">
			<Container maxW="xl">
				<JobApplicationContainer jobId={jobId} />
			</Container>
		</Center>
	);
};
